import { useQuery } from '@tanstack/react-query';
import { pendingAffiliateService } from 'v2/services/affiliate/pendingAffiliate';

export const usePendingAffiliatesSummaryCount = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['pendingAffiliatesSummaryCount'],
    queryFn: () => pendingAffiliateService.getPendingAffiliatesSummaryCount()
  });

  return {
    summaryCount: data?.data,
    isLoading,
    refetch
  };
};
